// extracted by mini-css-extract-plugin
export default {"root":"SvPh5","color-green":"_3e2Wi","colorGreen":"_3e2Wi","color-red":"_1oLAD","colorRed":"_1oLAD"};